import { render, staticRenderFns } from "./TreeViewItem.vue?vue&type=template&id=67fc71d8&scoped=true&"
import script from "./TreeViewItem.vue?vue&type=script&lang=js&"
export * from "./TreeViewItem.vue?vue&type=script&lang=js&"
import style0 from "./TreeViewItem.vue?vue&type=style&index=0&id=67fc71d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fc71d8",
  null
  
)

export default component.exports